/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VipDiscountCompanyDto } from '../../models/vip-discount-company-dto';

export interface GetGivenVipDiscountCompanies$Params {
}

export function getGivenVipDiscountCompanies(http: HttpClient, rootUrl: string, params?: GetGivenVipDiscountCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VipDiscountCompanyDto>>> {
  const rb = new RequestBuilder(rootUrl, getGivenVipDiscountCompanies.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VipDiscountCompanyDto>>;
    })
  );
}

getGivenVipDiscountCompanies.PATH = '/discounts/vip/given/companies';
